var url = "c17844ccdb2c0eb0bb0384e7b1c5e46e.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;